import { useApiQuery } from '@/api/main/query'
import { MerchantCommissionsModel } from '../model'

export const useMerchantCommissions = () => {
  const endpoint = '/v1/merchant/сommissions/incoming'

  const { data, error, isLoading } = useApiQuery<MerchantCommissionsModel>(
    ['merchant-commissions'],
    endpoint
  )

  return {
    data,
    error,
    isLoading,
    merchantId: data?.merchantId,
    baseCommission: data?.settingsProfile?.baseCommission || 0,
    dailyCommissionDelta: data?.dailyVolumeCommissionProfile?.commissionDelta || 0,
    monthlyCommissionDelta: data?.monthlyVolumeCommissionProfile?.commissionDelta || 0,
    isPaymentVolumeEnabled: data?.settingsProfile?.isEnabledPaymentVolumeMethod || false,
    isDailyVolumeEnabled: data?.settingsProfile?.isEnabledDailyVolumeMethod || false,
    isMonthlyVolumeEnabled: data?.settingsProfile?.isEnabledMonthlyVolumeMethod || false,
    ourCommissionPart: data?.settingsProfile?.ourCommissionPart || 0,
    traderCommissionPart: data?.settingsProfile?.traderCommissionPart || 0,
    refCommissionPart: data?.settingsProfile?.refCommissionPart || 0,
  }
}
